import { css, media, styled } from '@nx-kit/styling';
import Button from 'components/atoms/Button/Button';

export const Wrapper = styled.div`
  display: flex;
  gap: 15px;
  overflow-x: auto;
  width: 100%;
  align-items: flex-start;
  padding-bottom: 5px;

  ${media('lg')} {
    overflow: unset;
    flex-wrap: wrap;
    width: auto;
    padding-bottom: 0;
  }
`;

export const ButtonStyled = styled(Button)<{ selected: boolean; onClick: any }>`
  border-radius: 6px;
  padding: 0 15px;
  height: 36px;
  flex: 1;
  min-width: fit-content;

  ${(props) =>
    props.selected
      ? css`
          background-color: ${(props) => props.theme.global.color.primary};
          color: ${props.theme.global.color.white};
        `
      : css`
          background-color: ${props.theme.global.color.gray50};
          color: ${props.theme.global.color.gray900};
        `};
`;
